import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';
  angular.module('app').service('DiscountCouponService', DiscountCouponService);

  DiscountCouponService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    'UtilService',
    '$translate',
    '$filter',
    'SessionService',
  ];

  function DiscountCouponService(
    RestResource,
    config,
    UtilService,
    $translate,
    $filter,
    SessionService
  ) {
    const utils = new UtilService(this);

    let apiUrl = environment.apiEndpoint + 'discount_coupons';

    const service = {
      getFilterCriteria: getFilterCriteria,
      getDiscountCoupons: getDiscountCoupons,
      getDiscountCoupon: getDiscountCoupon,
      saveDiscountCoupon: saveDiscountCoupon,
      changeDiscountCouponStatus: changeDiscountCouponStatus,
      deleteDiscountCoupon: deleteDiscountCoupon,
      setDiscounCoupon: setDiscounCoupon,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      const filterCriteria = {
        page: 1,
        sortDir: 'desc',
        sortedBy: 'created_at',
      };

      return filterCriteria;
    }

    function getDiscountCoupons(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getDiscountCoupon(discountCouponId) {
      let url = apiUrl + '/' + discountCouponId;

      return RestResource.request(
        'get',
        url,
        {},
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveDiscountCoupon(discount_coupon, language) {
      let method;
      let url = apiUrl;

      if (!discount_coupon.id) {
        // create
        method = 'post';
        discount_coupon.company_id = SessionService.getSelectedAccountCompany().id;
      } else {
        method = 'put';
        url += '/' + discount_coupon.id;
      }

      language = language || config.DEFAULT_CONTENT_LANGUAGE;

      return RestResource.request(
        method,
        url,
        { discount_coupon: discount_coupon, lang: language },
        function (response) {
          let msg = !discount_coupon.id ? 'DISCOUNT_COUPON_ADDED' : 'DISCOUNT_COUPON_MODIFIED';
          utils._successMsg($translate.instant(msg));

          return response.data;
        },
        function (response) {
          return response.data;
        }
      );
    }

    function changeDiscountCouponStatus(discount_coupon, successCallback) {
      let url = apiUrl + '/' + discount_coupon.id + '?set_status=true';

      let newStatus = discount_coupon.status === config.ACTIVE ? config.INACTIVE : config.ACTIVE;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          let params = {
            title: 'DEACTIVATE_DISCOUNT_COUPON',
            // body:       'DEACTIVATE_DISCOUNT_COUPON_WARNING',
            requireConfirmation: true,
            successMsg: 'DISCOUNT_COUPON_DEACTIVATED',
          };

          utils.changeItemStatus(url, discount_coupon, params, successCallback);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function deleteDiscountCoupon(discountCouponId, successCallback) {
      let url = apiUrl + '/' + discountCouponId;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'DELETE_DISCOUNT_COUPON',
            // body:       'DELETE_DISCOUNT_COUPON_WARNING',
            mode: 'danger',
            reason: 'DELETE_ITEM_REASON',
            requireConfirmation: true,
            successMsg: 'DISCOUNT_COUPON_DELETED',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function setDiscounCoupon(discount_coupon, currency) {
      let label =
        discount_coupon.discount_type === 'percentage'
          ? discount_coupon.value + '%'
          : $filter('currency')(discount_coupon.value, currency.symbol) + ' ' + currency.code;

      return {
        id: discount_coupon.id,
        coupon_code: discount_coupon.coupon_code,
        discount_type: discount_coupon.discount_type,
        value: discount_coupon.value,
        label: label,
      };
    }
  }
})();

// : $filter('currency')(discount_coupon.value, discount_coupon.price_list.currency.symbol) +' '+ discount_coupon.price_list.currency.code;
// : $filter('currency')(discount_coupon.value, currency.symbol) +' '+ currency.code;
